export function validateEmployeeCount(employeeCount) {
    const errors = [];
    if (isNaN(employeeCount) || employeeCount < 1) {
        errors.push('hiring.employees.validation.required');
    }
    if (employeeCount > 9999) {
        errors.push('hiring.employees.validation.max');
    }
    return {
        isValid: errors.length === 0,
        errors,
    };
}
export function formatEmployeeCountDisplay(employeeCount) {
    return employeeCount.toString().padStart(2, '0');
}
